module.exports = __webpack_public_path__ + "img/vote-big.f8e2dceb.png";